module.exports = __webpack_public_path__ + "static/media/Manual_Thermomix-TM6_USA-Canada-Mexico.93527315.pdf";